// extracted by mini-css-extract-plugin
module.exports = {"HeaderStep":"HeaderStep_HeaderStep__ibj4K","TitoloStep":"HeaderStep_TitoloStep__nGOwB","SottotitoloStep":"HeaderStep_SottotitoloStep__Yxc_p"};